<template>
    <o-modal @showModal="showModal" @close="closeModal">
        <template v-slot:header>
            {{ item.title }}
        </template>
        <template v-slot:body>
            <o-form autocomplete="off">
                <div v-if="errors.length">
                    <div class="custom-alert modern-alert error-alert mb-4">
                        <div class="alert-icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </div>
                        <div class="alert-content">
                            <h6 class="alert-title">Please correct the following error(s):</h6>
                            <ul class="alert-list">
                                <li v-for="(item, index) in errors" :key="index">{{ item }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <o-form-group title="Tier Name" name="name" class="text-start mb-4 form-group-modern">
                    <span class="text-danger"> *</span>
                    <o-input-text name="name" :autocomplete="'off'" v-model="item.name" type="text" class="modern-input" placeholder="Enter tier name e.g. Gold" />
                </o-form-group>
                <o-form-group title="Minimum Transaction Value" name="member_tier" class="text-start mb-4 form-group-modern">
                    <span class="text-danger"> *</span>
                    <o-input-text name="member_tier" :autocomplete="'off'" v-model="item.transaction_value_min" type="text" mask="idr" class="modern-input" placeholder="0" />
                </o-form-group>
                <o-form-group title="Tier Icon" name="uploadImage" class="text-start mb-2">
                    <span class="text-danger"> *</span>
                    <o-image-input :imageurl="item.icon" @selectImage="imageSelected" class="mt-2" />
                </o-form-group>
                <div class="d-flex justify-content-between mt-4">
                    <button @click.prevent="closeModal" class="btn btn-light text-white px-4 fw-medium" type="button" style="background-color: #B9B9B9; border: none;">Cancel</button>
                    <o-button @click="saveDetail" :variant="'primary'" type="submit" class="px-4 text-white">Save</o-button>
                </div>
            </o-form>
        </template>
    </o-modal>
</template>

<script>
import { OModal, OForm, OFormGroup, OInputText, OButton, OImageInput } from '@/components/OmnihControl';
import { mapState } from 'vuex';
import store from '@/store/';

export default {
    name: 'AddDetail',
    components: {
        OModal,
        OForm,
        OFormGroup,
        OInputText,
        OButton,
        OImageInput
    },
    props: [
        'editedItem',
        'validationdetail',
    ],
    data() {
        return {
            item: {
                name: '',
                transaction_value_min: '',
                icon: '',
                title: 'New Member Tier'
            },
            validationDetail: this.validationdetail,
            isModalVisible: false,
            errors: [],
        }
    },
    mounted() {
        if (Object.keys(this.editedItem).length !== 0) {
            this.item = { ...this.editedItem };
            this.item.transaction_value_min = this.priceFormat(this.item.transaction_value_min);
            this.item.icon = this.editedItem.item?.icon?.image_url; 
            this.item.title = 'Edit Member Tier';
        }
    },
    methods: {
        showModal() {
            this.isModalVisible = true;
        },
        closeModal(e) {
            if (e && e.preventDefault) {
                e.preventDefault();
            }
            this.$emit('parentCloseModal');
        },
        imageSelected(imageUrl) {
            this.item.icon = imageUrl;
        },
        async saveDetail() {
            this.errors = [];
            
            const transactionValueMin = this.item.transaction_value_min.replace(/\./g, '');

            if (this.item.name === "") {
                this.errors.push('Name required.');
            }

            if (transactionValueMin === "") {
                this.errors.push('Min transaction required.');
            }

            if (this.item.icon === "") {
                this.errors.push('Icon cannot be empty.');
            }

            if (this.editedItem.title != 'Edit Value') {
                try {
                    const businessProfile = await store.dispatch('Auth/getBusinessProfile');
                    const data = {
                        name: this.item.name,
                        transaction_value_min: this.item.transaction_value_min,
                        icon: this.item.icon,
                        corporate_id: businessProfile.corporate_id
                    }
                    try {
                        const resp = await store.dispatch('MemberTier/check', { data: data });
                        if (resp.data.data.includes('already exists')) {
                            this.errors.push(resp.data.data);
                        }
                    } catch (error) {
                        console.error('An unexpected error occurred', error);
                    }
                } catch (error) {
                    console.error('Error fetching business profile', error);
                }
            } else {
                try {
                    const businessProfile = await store.dispatch('Auth/getBusinessProfile');
                    const data = {
                        name: this.item.name,
                        transaction_value_min: this.item.transaction_value_min,
                        icon: this.item.icon,
                        corporate_id: businessProfile.corporate_id,
                        item_id: this.editedItem.id
                    }
                    try {
                        const resp = await store.dispatch('MemberTier/check', { data: data });
                        if (resp.data.data) {
                            if (resp.data.data.includes('already exists')) {
                                this.errors.push(resp.data.data);
                            }
                        }
                    } catch (error) {
                        console.error('An unexpected error occurred', error);
                    }
                } catch (error) {
                    console.error('Error fetching business profile', error);
                }
            }

            if (this.errors.length === 0) {
                this.item.transaction_value_min = transactionValueMin;
                this.$emit('parentAddItem', this.item);
                this.isModalVisible = false;
            }
        },
        priceFormat(value) {            
            const formated = value.toString().replace(/[^0-9]/g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
            return formated;
        }
    },
    computed: {
        ...mapState({}),
    }
}
</script>

<style>
.spinner {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.5);
    height: 100%;
    width: 100%;
}
.spinner-position {
    display: block;
    position: fixed;
    z-index: 1031;
    top: 50%;
    right: 50%;
    margin-top: 5px;
    margin-left: 80px;
}

/* Modern Form Styles */
.form-group-modern {
    font-weight: 500;
    color: #475569;
}

.modern-input {
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    padding: 10px 14px;
    font-size: 14px;
    transition: border-color 0.2s, box-shadow 0.2s;
    width: 100%;
    margin-top: 6px;
}

.modern-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    outline: none;
}

.btn-save-modern {
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 600;
    transition: transform 0.1s, box-shadow 0.1s;
}

.btn-save-modern:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 8px -1px rgba(59, 130, 246, 0.5);
}

.btn-action-secondary {
    background-color: #f1f5f9;
    color: #475569;
    border: 1px solid #e2e8f0;
    font-weight: 500;
    padding: 8px 16px;
    border-radius: 6px;
    transition: all 0.2s;
}

.btn-action-secondary:hover {
    background-color: #e2e8f0;
    color: #0f172a;
}

/* Modern Alert Styles */
.modern-alert {
  display: flex;
  align-items: flex-start;
  background-color: #fef2f2;
  border-left: 5px solid #ef4444;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  animation: fadeIn 0.3s ease-out;
}

.modern-alert .alert-icon {
  flex-shrink: 0;
  margin-right: 14px;
  font-size: 20px;
  color: #ef4444;
}

.modern-alert .alert-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: #991b1b;
}

.alert-list {
  margin: 0;
  padding-left: 16px;
  font-size: 13px;
  color: #b91c1c;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>